import { Close, Delete, Edit } from '@mui/icons-material';
import DescriptionIcon from '@mui/icons-material/Description';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import { Popover } from '@mui/material';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Frequency } from 'rrule';

import { dateUtils } from '../../utils/dateUtils';

interface IPros {
  // currentEvent: EventForm;
  onClose: () => void;
  onEventPopupClick: (eventType: string) => void;
  // anchorEl: any;
  // currentCellInfo: any;
}
const EventDetailPopOver = ({ onClose, onEventPopupClick }: IPros, ref) => {
  const [currentCellEvent, setCurrentCellEvent] = useState(null);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  useImperativeHandle(ref, () => ({
    open(el, currentCell, currentEvent) {
      // console.log('open popover', { el, currentCell, currentEvent });
      setCurrentCellEvent(currentCell && currentCell.event ? currentCell.event : null);
      setAnchorEl(el);
      setCurrentEvent(currentEvent);
    },
    close() {
      setCurrentCellEvent(null);
      setAnchorEl(null);
      setCurrentEvent(null);
    },
  }));

  if (!currentEvent) {
    return null;
  }

  return (
    <Popover
      id={currentEvent.id}
      open={Boolean(anchorEl)}
      anchorEl={document.getElementsByTagName('body')[0]}
      onClose={onClose}
      // anchorPosition={{ top: 100, left: 100 }}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
    // transformOrigin={{
    //   vertical: 'center',
    //   horizontal: 'center',
    // }}
    >
      <div className="e-event-popup">
        <div className="e-popup-header">
          <div className="e-header-icon-wrapper">
            <span className="icon" title="Edit">
              <Edit fontSize="small" onClick={() => onEventPopupClick('Edit')} />
            </span>
            <span className="icon" title="Delete">
              <Delete fontSize="small" onClick={() => onEventPopupClick('Delete')} />
            </span>
            <span className="icon" title="Close">
              <Close fontSize="small" onClick={() => onEventPopupClick('Close')} />
            </span>
          </div>
          <div className="e-subject-wrap">
            <div className="e-subject e-text-ellipsis" title={currentEvent.title}>
              {currentEvent.title}
            </div>
          </div>
        </div>
        <div className="e-popup-content">
          <div className="e-date-time">
            <WorkHistoryOutlinedIcon className="date-time-icon" />
            <div className="e-date-time-wrapper e-text-ellipsis">
              {currentCellEvent && (
                <div className="e-date-time-details e-text-ellipsis">
                  {dateUtils.format(currentCellEvent.startStr, currentEvent.timezone, 'MMDD')}(
                  {dateUtils.format(currentCellEvent.startStr, currentEvent.timezone, 'hh:mm a')} -{' '}
                  {dateUtils.format(currentCellEvent.endStr, currentEvent.timezone, 'hh:mm a')})
                </div>
              )}
              {currentEvent && currentEvent.rrule && (
                <div className="e-recurrence-summary e-text-ellipsis">Every {Frequency[currentEvent.rrule.freq]}(s)</div>
              )}
            </div>
          </div>

          {currentEvent.description && (
            <div className="e-description">
              <DescriptionIcon className="e-description-icon" /> {currentEvent.description}
            </div>
          )}
        </div>
        <div className="e-popup-footer">
          <button type="button" className="e-event-edit e-text-ellipsis e-control e-btn e-lib e-flat e-primary" title="Edit">
            Edit
          </button>
          <button type="button" className="e-event-delete e-text-ellipsis e-control e-btn e-lib e-flat" title="Delete">
            Delete
          </button>
        </div>
      </div>
    </Popover>
  );
};

export default forwardRef(EventDetailPopOver);
